import React from 'react';

interface DemoCardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
  shadow?: 'sm' | 'md' | 'lg';
  border?: boolean;
}

const DemoCard: React.FC<DemoCardProps> = ({ 
  children, 
  className = '', 
  padding = 'md',
  shadow = 'sm',
  border = true 
}) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };

  const shadowClasses = {
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg'
  };

  const baseClasses = 'bg-white rounded-lg';
  const borderClasses = border ? 'border border-gray-200' : '';
  
  return (
    <div className={`${baseClasses} ${borderClasses} ${shadowClasses[shadow]} ${paddingClasses[padding]} ${className}`}>
      {children}
    </div>
  );
};

export default DemoCard;
